import AddressAutocompleteInput from "../AddressAutocompleteInput";
import { camposDireccionDesdePlaces } from "../../utils/googlePlacesAddressLine";
import { ESTADOS_CIVILES, REGIMENES_MATRIMONIALES, SEXOS } from "../../utils/parteExpedienteCampos";

/**
 * Bloque reutilizable: dirección (Google) + datos personales para escritura notarial.
 */
export default function CamposNotariaParteExpediente({
  form,
  setForm,
  inp,
  sel,
  lbl,
  sinDireccion = false,
  compact = false,
}) {
  const labelSt = lbl || { fontSize: 10, fontWeight: 700, opacity: 0.75, display: "block", marginBottom: 3 };
  const grid = { display: "grid", gridTemplateColumns: "1fr 1fr", gap: compact ? 6 : 10 };

  const camposNotaria = (
    <>
      <div>
        <label style={labelSt}>Estado civil</label>
        <select style={sel} value={form.estado_civil || ""} onChange={(e) => setForm((f) => ({ ...f, estado_civil: e.target.value }))}>
          {ESTADOS_CIVILES.map((v) => (
            <option key={v || "—"} value={v}>{v || "—"}</option>
          ))}
        </select>
      </div>
      <div>
        <label style={labelSt}>Régimen matrimonial</label>
        <select style={sel} value={form.regimen_matrimonial || ""} onChange={(e) => setForm((f) => ({ ...f, regimen_matrimonial: e.target.value }))}>
          {REGIMENES_MATRIMONIALES.map((v) => (
            <option key={v || "—"} value={v}>{v || "—"}</option>
          ))}
        </select>
      </div>
      <div>
        <label style={labelSt}>Profesión</label>
        <input style={inp} value={form.profesion || ""} onChange={(e) => setForm((f) => ({ ...f, profesion: e.target.value }))} />
      </div>
      <div>
        <label style={labelSt}>Sexo</label>
        <select style={sel} value={form.sexo || ""} onChange={(e) => setForm((f) => ({ ...f, sexo: e.target.value }))}>
          {SEXOS.map((v) => (
            <option key={v || "—"} value={v}>{v || "—"}</option>
          ))}
        </select>
      </div>
      <div style={{ gridColumn: "span 2" }}>
        <label style={labelSt}>Nacionalidad</label>
        <input style={inp} value={form.nacionalidad || ""} onChange={(e) => setForm((f) => ({ ...f, nacionalidad: e.target.value }))} placeholder="España…" />
      </div>
    </>
  );

  return (
    <>
      {!sinDireccion && (
        <div style={{ marginBottom: compact ? 6 : 10 }}>
          <label style={labelSt}>Dirección</label>
          <AddressAutocompleteInput
            value={form.direccion || ""}
            onValueChange={(v) => setForm((f) => ({ ...f, direccion: v }))}
            onPlaceAddressResolved={(parts) => setForm((f) => ({
              ...f,
              ...camposDireccionDesdePlaces(parts, f),
            }))}
            placeholder="Calle, CP, población..."
            style={inp}
          />
        </div>
      )}
      <div style={grid}>{camposNotaria}</div>
    </>
  );
}
